<template>
  <div class="profit-analysis">
    <gj-analysis-panel
        :title="'店铺-盈利分析'"
    >
      <template #subtitle>
        <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :show-list= "['refresh']"
            :showPanelBtn="true"
            :isShowPanel="isShowPanel"
            @refresh="refresh"
            @showPanel="showPanel"
        />
      </template>
      <template #panelBody>
        <div class="profit-analysis-content">
          <el-row :gutter="10">
            <el-col :span="10" v-if="!isShowPanel">
              <el-card class="box-card card460"  v-loading="loading">
                <Chart :type="'bar'" :height="'420px'" :option="profitAnalysisOption"/>
              </el-card>
            </el-col>
            <el-col :span="14" v-if="!isShowPanel">
              <el-card class="box-card card460">
                <gj-table
                    :width="'100%'"
                    :adapt-height="false"
                    :height="400"
                    ref="gjTable"
                    :index="false"
                    :loading="loading"
                    :data="tableData"
                    :columns="columns"
                    :border="false"
                >
                  <template v-slot:marketId="{row}">
                    {{ row.marketId | optionText(marketOption) | defaultShow }}
                  </template>
                  <template v-slot:quadrant="{row}">
                    {{ row.quadrant}}
                  </template>
                  <template v-slot:saleroom="{row}">
                    {{ row.currencySymbol }}{{ row.saleroom | amount}}
                    <ChainRatio :isBlock="true" :percent="parseInt(row.saleProportion)"/>
                  </template>
                  <template v-slot:turnover="{row}">
                    {{ (row.turnover).toFixed(2)}}
                    <ChainRatio :isBlock="true" :percent="parseInt(row.turnoverProportion)"/>
                  </template>
                  <template v-slot:profitRate="{row}">
                    {{ row.profitRate}}%
                    <ChainRatio :isBlock="true" :percent="parseInt(row.profitRateProportion)"/>
                  </template>
                </gj-table>
              </el-card>
            </el-col>
            <el-col :span="24" v-if="isShowPanel">
              <div class="panel-group">
                <div class="panel-left-group">
                  <div class="panel-group-left">
                    <img src="../../../../../assets/images/panel/orderSiteDistributionLeft@1x.png" />
                  </div>
                  <div class="panel-group-middle">
                    <img src="../../../../../assets/images/panel/profitAnalysisMiddle@1x.png" />
                  </div>
                </div>

                <div class="panel-group-right">
                  <img src="../../../../../assets/images/panel/profitAnalysisRight@1x.png" />
                </div>
              </div>
              <div class="panel-group-right-btn-group">
                <gj-button class="panel-group-right-btn" :style="{float: 'right'}" @click="showPanel(false)">返回看板</gj-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </gj-analysis-panel>
    <gj-modal
            :visible="modalVisible"
            :destroyOnClose="true"
            size="full"
            @cancel="cancel"
            :contentStyle="{height: '100%'}"
    >
      <div slot="content" :style="{height: '100%'}">
        <EnlargeChart :type="'bar'" :height="'100%'" :option="enlargeProfitAnalysisOption"/>
      </div>
    </gj-modal>
  </div>
</template>

<script>
import Chart from "@/views/components/chart/chart"
import EnlargeChart from "@/views/components/chart/enlarge-chart"
import OptionGroup from "@/views/components/option-panel-group/option-group"
import {getProfitProfileData} from "@/api/statistics"
import {mapGetters} from "vuex";
import ChainRatio from "@/views/components/chain-ratio/chain-ratio"
import {convertToFullDate, dateShortcut} from "@/utils/date.util";
import _ from "lodash"
import { amount } from "@/filters";
export default {
  name: "profit-analysis",
  components: { Chart,OptionGroup,ChainRatio,EnlargeChart },
  inject: ['getPageParams'],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
    startDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
    filter () {
      return this.getPageParams()
    },
  },

  data(){
    return{
      useCache: false,
      modalVisible: false,
      isShowPanel: false,
      profitAnalysisOption: {},
      enlargeProfitAnalysisOption: {},
      loading: false,
      columns: [
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '80px',default: true, disabled: true, align: 'left', options: () => this.marketOption},
        {id: 'quadrant', header: '所处象限', field: 'slot:quadrant', minWidth: '100px',align: 'left'},
        {id: 'saleroom', header: '销售额', field: 'slot:saleroom', scale: 2, minWidth: '100px', align: 'right'},
        {id: 'turnover', header: '日周转', field: 'slot:turnover', minWidth: '100px', align: 'right'},
        {id: 'profitRate', header: '净成本毛利率', field: 'slot:profitRate', minWidth: '100px', align: 'right'},
      ],
      tableData: [],
      //图表seriesData
      seriesData: [],
    }
  },
  mounted() {
    this.initprofitAnalysisOptionScatterParams();
    this.$gjQuery()
  },
  methods: {
    /**
     * 获取全部初始化界面数据
     */
    $gjQuery(){
      this.getProfitProfileData();
    },
    /**
     * 刷新界面
     */
    refresh(){
      this.$gjQuery();
    },
    /**
     *  显示看板
     */
    showPanel(value){
      this.isShowPanel = value;
    },
    /**
     * 获取盈利分析
     */
    getProfitProfileData(){
      this.loading = true;
      let params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      };
      getProfitProfileData(params).then(res=>{
        let data = res;
        //拼装左侧图表数据,通过 x轴 y轴获取最大值，双轴刻度平均分成四象限
        let seriesData = [];
        let xMax = 0;    //X轴最大值
        let yMax = 0;    //Y轴最大值
        let zMax = 0;    //Z轴最大值
        for(let i=0;i<data.length;i++){
          xMax = xMax > _.toNumber(data[i].profitRate) ? xMax : _.toNumber(data[i].profitRate);
          yMax = yMax > _.toNumber(data[i].turnover) ? yMax : _.toNumber(data[i].turnover);
          zMax = zMax > _.toNumber(data[i].saleroom) ? zMax : _.toNumber(data[i].saleroom);
          seriesData[i] = [_.toNumber(data[i].profitRate), _.toNumber(data[i].turnover), data[i].marketName,
            _.toNumber(data[i].saleroom), _.toNumber(data[i].area)];
        }
        this.seriesData = seriesData;
        xMax = _.ceil((xMax || 40)/ 4) * 4
        // yMax = _.ceil((yMax || 40)/ 4) * 4
        this.initprofitAnalysisOptionScatterParams(xMax,yMax, zMax);
        //拼装右侧图表数据
        this.tableData = data;
      }).complete(()=>{this.loading = false;})
    },
    initprofitAnalysisOptionScatterParams(xMax, yMax, zMax) {
      const _this = this;
      const option = {
        toolbox:{
          showTitle: false,
          feature: {
            myTool: {
              show: true,
              title: '放大图表',
              icon: 'path://M28.218699 28.359788H255.971785v-28.218695H0.000004v255.971782h28.218695V28.359788zM767.887129 0.141093v28.218695h227.753087v227.753087h28.218694V0.141093h-255.971781zM995.640216 995.781305h-227.753087v28.218695H255.971785v-28.218695H28.218699v-227.724868h-28.218695v255.943563h1023.858906v-255.943563h-28.218694v227.724868z',
              onclick: function (){
                _this.enlargeChart();
              }
            }
          }
        },
        xAxis: {
          name: '净成本毛利率',
          nameTextStyle:{
            color: "#32393d"
          },
          min: 0,
          interval: (xMax || 40) / 4,
          max: xMax || 40,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#e5e9f2"
            }
          },
          axisLabel: {
            margin: 10,
            formatter: "{value}%",
            color: "#32393d"
          },
        },
        grid:{
          top: "20%",
          left: '10%',
          right: "20%"
        },
        yAxis: {
          name: "日周转",
          nameTextStyle:{
            color: "#32393d"
          },
          min: 0,
          interval: (yMax || 40) / 4,
          max: yMax || 40,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#e5e9f2"
            }
          },
          axisLabel: {
            margin: 10,
            color: "#32393d",
            formatter:function (value) {
              if (String(value).includes(".")) {
                return value.toFixed(2);
              }
              return value;
            }
          },
        },
        color: ["#8EBAFF"],
        series: [{
          symbolSize: (params) =>{
            let sign = (params[3] / zMax) * 50
            sign < 10 && (sign = 10)
            return sign
          },
          data: this.seriesData,
          type: 'scatter',
          label: {
            show: true,
            position: 'top',
            formatter:  (param) => {
              let marketName = param.value[2];
              let saleroom = amount(param.value[3])
              let currencySymbol = "";
              if (this.tableData[0] && this.tableData[0].currencySymbol) {
                currencySymbol = this.tableData[0].currencySymbol;
              }
              return `${marketName}   销售额：${currencySymbol}${saleroom}`
            },
          },
        }]
      };
      this.profitAnalysisOption = option;
      // console.log(this.profitAnalysisOption, '图标数据')
      let otherOption = _.cloneDeep(option);
      otherOption.toolbox = {};
      otherOption.grid = {
        top : "20%",
        bottom: "10%"
      };
      this.enlargeProfitAnalysisOption = otherOption
      // console.log(this.enlargeProfitAnalysisOption)
    },
    /**
     * 放大图表
     */
    enlargeChart(){
      this.modalVisible = true;
    },
    cancel(){
      this.modalVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common/index.scss";

.profit-analysis {
  // margin-top: 10px;
  //padding: 40px 0px 0 0px;
  //margin-top: -40px;
}
.panel-group{
  width: 100%;
  //height: 100%;
  min-height: 342px;
  height: 420px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  .panel-left-group{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .panel-group-middle{
      margin-left: 30px;
    }
  }

  .panel-group-right{
    text-align: center;
    img{
      width: 562px;
      height: 269px;
    }
  }
}
/deep/ .gj-analysis-panel{
  margin-top: 6px;
}
/deep/ .left-option-header{
  margin-top: 0;
}
/deep/ .left-option-header-title{
  margin-bottom: 0;
}
</style>
